"use strict";

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = _promise2.default))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../util/index");

var restpaginator_1 = require("../restpaginator");

var channeldescriptor_1 = require("../channeldescriptor");
/**
 * Public channels collection
 * It's a cassandra-backed pull-based collection
 */


var PublicChannels = function () {
  function PublicChannels(client, services, url) {
    (0, _classCallCheck3.default)(this, PublicChannels);
    this.client = client;
    this.services = services;
    this.url = url;
  }

  (0, _createClass3.default)(PublicChannels, [{
    key: "getChannels",
    value: function getChannels() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _this = this;

        var url, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = new index_1.UriBuilder(this.url).arg('PageToken', args.pageToken).build();
                _context.next = 3;
                return this.services.network.get(url);

              case 3:
                response = _context.sent;
                return _context.abrupt("return", new restpaginator_1.RestPaginator(response.body.channels.map(function (x) {
                  return new channeldescriptor_1.ChannelDescriptor(_this.client, x);
                }), function (pageToken) {
                  return _this.getChannels({
                    pageToken: pageToken
                  });
                }, response.body.meta.previous_token, response.body.meta.next_token));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getChannelBySid",
    value: function getChannelBySid(sid) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var url, response;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = new index_1.UriBuilder(this.url).path(sid).build();
                _context2.next = 3;
                return this.services.network.get(url);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", new channeldescriptor_1.ChannelDescriptor(this.client, response.body));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getChannelByUniqueName",
    value: function getChannelByUniqueName(uniqueName) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var url, response;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = new index_1.UriBuilder(this.url).path(uniqueName).build();
                _context3.next = 3;
                return this.services.network.get(url);

              case 3:
                response = _context3.sent;
                return _context3.abrupt("return", new channeldescriptor_1.ChannelDescriptor(this.client, response.body));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }]);
  return PublicChannels;
}();

exports.PublicChannels = PublicChannels;